(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3817],{

/***/ 73817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Content038": function() { return /* binding */ Content038; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87900);
/* harmony import */ var _Content038_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64231);
/* harmony import */ var _Content038_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Content038_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var Content038 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var list = (ref1 = payload === null || payload === void 0 ? void 0 : payload.list) !== null && ref1 !== void 0 ? ref1 : [];
    var ref2;
    var template = (ref2 = payload === null || payload === void 0 ? void 0 : payload.template) !== null && ref2 !== void 0 ? ref2 : "light";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Content038_module_scss__WEBPACK_IMPORTED_MODULE_3___default().wrapper), (_Content038_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[template]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Content038_module_scss__WEBPACK_IMPORTED_MODULE_3___default().block),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Heading5 */ .by, {
                        className: (_Content038_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_Content038_module_scss__WEBPACK_IMPORTED_MODULE_3___default().content),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .OrderedList */ .GS, {
                            items: list,
                            appearance: "bold",
                            className: (_Content038_module_scss__WEBPACK_IMPORTED_MODULE_3___default().list)
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Content038);


/***/ }),

/***/ 64231:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content038_wrapper__lYDu1","light":"Content038_light___nGB7","grey":"Content038_grey__U_Uep","block":"Content038_block__6dXZn","title":"Content038_title__6u26h","content":"Content038_content__uHzVM","list":"Content038_list__yYDQW"};

/***/ })

}]);